import { Atom } from 'AppReact';
import styled from "styled-components";

const template = styled.div`
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 29px;
    letter-spacing: 0.02em;
    color: #000000;
`;


export default Atom({ type: 'label', dataType:'string', template })
